import { size, toLower, includes, filter, keyBy, sortBy } from "lodash";

export const ORGANISATION_UNIT_STATUSES = {
  DRAFT: "draft",
  ARCHIVED: "archived"
};

export const getColorByStatus = status => {
  switch (status.toLowerCase()) {
    case ORGANISATION_UNIT_STATUSES.ARCHIVED:
      return "red";
    case ORGANISATION_UNIT_STATUSES.DRAFT:
    default:
      return "gray";
  }
};

export const searchDeep = (searchText, unit) => {
  if (includes(toLower(unit.name), toLower(searchText))) {
    return true;
  }
  unit.organisationUnits = filter(unit.organisationUnits, childUnit =>
    searchDeep(searchText, childUnit)
  );

  return size(unit.organisationUnits);
};

export const filterDeep = (units, searchText) =>
  filter(units, unit => searchDeep(searchText, unit));

export const getOrganisationsAsTreeStructure = units => {
  return nest(units);
};

export const nest = (items, id = null, link = "parentId") =>
  items
    .filter(item => item[link] === id)
    .map(item => ({
      ...item,
      organisationUnits: nest(items, item.id)
    }));

const getOrganisationPath = (unit, unitsById) => {
  const names = [];
  const visited = new Set();
  let current = unit;
  while (current && !visited.has(current.id)) {
    visited.add(current.id);
    names.unshift(current.name);
    current = unitsById[current.parentId];
  }
  return names.join(" > ");
};

export const withOrganisationPaths = units => {
  const unitsById = keyBy(units, "id");
  return sortBy(
    units.map(unit => {
      const path = getOrganisationPath(unit, unitsById);
      return {
        ...unit,
        path: unit.costCode ? `${path} (${unit.costCode})` : path
      };
    }),
    ["path"]
  );
};
